/**
 * Channels Basket Resource
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.2
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import { FunnelJourneyServerComponent } from './funnelJourney';
import { FunnelPassenger } from '../../stimson/session';
import { BundleCode, BundlesFareClass } from '../../../client-lib/apis/bff/methods/bundles/constants';
import { PassengerIdsPairing } from '../bundle';

/**
 *
 * @export
 * @interface AddonsGroupedLineItems
 */
export interface AddonsGroupedLineItems extends GroupedLineItems {}
/**
 *
 * @export
 * @interface FlexPassGroupedLineItems
 */
export interface FlexPassGroupedLineItems extends GroupedLineItems {}
/**
 *
 * @export
 * @interface AirfareDetails
 */
export interface AirfareDetails {
  /**
   *
   * @type {string}
   * @memberof AirfareDetails
   */
  fareDisplayName: string;
  /**
   *
   * @type {BasketAggregateTotals}
   * @memberof AirfareDetails
   */
  totals: BasketAggregateTotals;
  /**
   *
   * @type {AirfareGroupedLineItems}
   * @memberof AirfareDetails
   */
  airfares: AirfareGroupedLineItems;
}
/**
 *
 * @export
 */
export type AirfareGroupedLineItems = Array<AirfareLineItem>;
/**
 *
 * @export
 * @interface AirfareLineItem
 */
export interface AirfareLineItem extends LineItem {
  /**
   *
   * @type {UnlocalisedStimsonFareType}
   * @memberof AirfareLineItem
   */
  fareType: UnlocalisedStimsonFareType;
  /**
   * LOCALIZED_ENRICHED Display name for the item
   * @type {string}
   * @memberof AirfareLineItem
   */
  airFareDisplayName: string;
  /**
   *
   * @type {PassengerType}
   * @memberof AirfareLineItem
   */
  paxType: PassengerType;
  /**
   * LOCALIZED_ENRICHED Display name for the item
   * @type {string}
   * @memberof AirfareLineItem
   */
  paxTypeDisplayName: string;
  /**
   *
   * @type {BasketPrice}
   * @memberof AirfareLineItem
   */
  netUnitPrice: BasketPrice;
  /**
   *
   * @type {BasketPrice}
   * @memberof AirfareLineItem
   */
  netTotalPrice: BasketPrice;
  /**
   *
   * @type {BasketPrice}
   * @memberof AirfareLineItem
   */
  apdUnitPrice: BasketPrice;
  /**
   *
   * @type {BasketPrice}
   * @memberof AirfareLineItem
   */
  apdTotalPrice: BasketPrice;
  /**
   * true if the pax is exempted from airport passenger duty (e.g. children)
   * @type {boolean}
   * @memberof AirfareLineItem
   */
  apdExempt: boolean;
  /**
   *
   * @type {number}
   * @memberof AirfareLineItem
   */
  totalDiscountAmount?: BasketPrice;
}

/**
 * @export
 * @namespace AirfareLineItem
 */
export namespace AirfareLineItem {}
/**
 *
 * @export
 * @interface BaseLineItem
 */
export interface BaseLineItem {
  /**
   * product / benefit code
   * @type {string}
   * @memberof BaseLineItem
   */
  code: string;
  /**
   * LOCALIZED_ENRICHED Display name for the item
   * @type {string}
   * @memberof BaseLineItem
   */
  displayName: string;
  /**
   * LOCALIZED_ENRICHED Additional long form text description
   * @type {string}
   * @memberof BaseLineItem
   */
  descriptionText?: string;
  /**
   *
   * @type {BasketPrice}
   * @memberof BaseLineItem
   */
  totalPrice: BasketPrice;
  /**
   *
   * @type {number}
   * @memberof BaseLineItem
   */
  orderingValue: number;
  /**
   * LOCALIZED_ENRICHED controls the visibilty of this line item
   * @type {boolean}
   * @memberof BaseLineItem
   */
  hideLineItem?: boolean;
}
/**
 *
 * @export
 * @interface BasketAggregate
 */
export interface BasketAggregate {
  /**
   *
   * @type {BasketAggregateTotals}
   * @memberof BasketAggregate
   */
  totals: BasketAggregateTotals;
  /**
   *
   * @type {Array<BasketAggregateItem>}
   * @memberof BasketAggregate
   */
  aggregatesLineItems: Array<BasketAggregateItem>;
}
/**
 *
 * @export
 * @interface BasketAggregateItem
 */
export interface BasketAggregateItem extends BaseLineItem {
  /**
   *
   * @type {number}
   * @memberof BasketAggregateItem
   */
  orderingValue: number;
  /**
   *
   * @type {BasketPrice}
   * @memberof BasketAggregateItem
   */
  PAY_NOW: BasketPrice;
  /**
   *
   * @type {BasketPrice}
   * @memberof BasketAggregateItem
   */
  PAY_LATER: BasketPrice;
}
/**
 *
 * @export
 * @interface BasketAggregateTotals
 */
export interface BasketAggregateTotals {
  /**
   *
   * @type {BasketPrice}
   * @memberof BasketAggregateTotals
   */
  total: BasketPrice;
  /**
   *
   * @type {BasketAggregateTotalsByPaymentStage}
   * @memberof BasketAggregateTotals
   */
  byPaymentStage: BasketAggregateTotalsByPaymentStage;
  /**
   *
   * @type {BasketAggregateTotalsByPaymentCollector}
   * @memberof BasketAggregateTotals
   */
  byPaymentCollector: BasketAggregateTotalsByPaymentCollector;
}
/**
 *
 * @export
 * @interface BasketAggregateTotalsByPaymentCollector
 */
export interface BasketAggregateTotalsByPaymentCollector {
  /**
   *
   * @type {BasketPrice}
   * @memberof BasketAggregateTotalsByPaymentCollector
   */
  EASYJET: BasketPrice;
  /**
   *
   * @type {BasketPrice}
   * @memberof BasketAggregateTotalsByPaymentCollector
   */
  CAR_LEASER: BasketPrice;
  /**
   *
   * @type {BasketPrice}
   * @memberof BasketAggregateTotalsByPaymentCollector
   */
  INSURER: BasketPrice;
}
/**
 *
 * @export
 * @interface BasketAggregateTotalsByPaymentStage
 */
export interface BasketAggregateTotalsByPaymentStage {
  /**
   *
   * @type {BasketPrice}
   * @memberof BasketAggregateTotalsByPaymentStage
   */
  PAY_NOW: BasketPrice;
  /**
   *
   * @type {BasketPrice}
   * @memberof BasketAggregateTotalsByPaymentStage
   */
  PAY_LATER: BasketPrice;
}
/**
 *
 * @export
 * @interface BasketGetQueryParams
 */
export interface BasketGetQueryParams {
  /**
   *
   * @type {string}
   * @memberof BasketGetQueryParams
   */
  funnelJourney?: BasketGetQueryParams.FunnelJourneyEnum;
  /**
   *
   * @type {string}
   * @memberof BasketGetQueryParams
   */
  outboundJourneyOfferKey?: string;
  /**
   *
   * @type {string}
   * @memberof BasketGetQueryParams
   */
  returnJourneyOfferKey?: string;
}

/**
 * @export
 * @namespace BasketGetQueryParams
 */
export namespace BasketGetQueryParams {
  /**
   * @export
   * @enum {string}
   */
  export enum FunnelJourneyEnum {
    None = <any>'none',
    Partial = <any>'partial',
    Full = <any>'full'
  }
}
/**
 *
 * @export
 * @interface BasketPrice
 */
export interface BasketPrice {
  /**
   *
   * @type {number}
   * @memberof BasketPrice
   */
  raw: number;
  /**
   *
   * @type {FormattedPrice}
   * @memberof BasketPrice
   */
  displayText: FormattedPrice;
}

/**
 *
 * @export
 * @interface BundlePrice
 */
export interface BundlePrice {
  /**
   *
   * @type {number}
   * @memberof BundlePrice
   */
  raw: number;
  /**
   *
   * @type {string}
   * @memberof BundlePrice
   */
  displayText: string;
  /**
   *
   * @type {Array<Adjustment>}
   * @memberof BundlePrice
   */
  adjustments?: Array<Adjustment>;
}

/**
 *
 * @export
 */
export type Adjustment = {
  /**
   *
   * @type {number}
   * @memberof Adjustment
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof Adjustment
   */
  code: string;
};

/**
 *
 * @export
 * @interface BasketResponse
 */
export interface BasketResponse {
  /**
   * Language code for basket content
   * @type {string}
   * @memberof BasketResponse
   */
  languageCode: string;
  /**
   * websiteRegionCode for the current basket
   * @type {string}
   * @memberof BasketResponse
   */
  websiteRegionCode: string;
  /**
   * Currency code for the current basket
   * @type {string}
   * @memberof BasketResponse
   */
  currencyCode: string;
  /**
   * ISO currency code for the current basket (in case its different from currency code e.g. CSK vs CZK)
   * @type {string}
   * @memberof BasketResponse
   */
  isoCurrencyCode: string;
  /**
   * Fare class indicating; flexi or bundles
   * @type {BundlesFareClass}
   * @memberof BasketResponse
   */
  fareClass: BundlesFareClass;
  /**
   * LOCALIZED_ENRICHED Fare display name
   * @type {string}
   * @memberof BasketResponse
   */
  fareDisplayName: string;
  /**
   * LOCALIZED_ENRICHED Offer display name (if exists)
   * @type {string}
   * @memberof BasketResponse
   */
  offerDisplayName?: string;
  /**
   *
   * @type {JourneyPairs}
   * @memberof BasketResponse
   */
  journeyPairs: JourneyPairs;
  /**
   *
   * @type {InsuranceGroupedLineItems}
   * @memberof BasketResponse
   */
  insurance?: InsuranceGroupedLineItems;
  /**
   *
   * @type {CarRentalGroupedLineItems}
   * @memberof BasketResponse
   */
  carRental?: CarRentalGroupedLineItems;
  /**
   *
   * @type {BasketAggregate}
   * @memberof BasketResponse
   */
  aggregate: BasketAggregate;
  /**
   *
   * @type {Array<Bundle>}
   * @memberof BasketResponse
   */
  bundles?: Array<Bundle>;
  /**
   *
   * @type {FunnelJourneyServerComponent | undefined}
   * @memberof BasketResponse
   */
  funnelJourney: FunnelJourneyServerComponent | undefined;
  /**
   *
   * @type {Array<Passenger>}
   * @memberof BasketResponse
   */
  passengers?: FunnelPassenger[];
  /**
   *
   * @type {BundleCode}
   * @memberof BasketResponse
   */
  bundleCode?: BundleCode;
}
/**
 *
 * @export
 * @interface BenefitLineItem
 */
export interface BenefitLineItem extends LineItem {}

/**
 * @export
 * @namespace BenefitLineItem
 */
export namespace BenefitLineItem {}
/**
 *
 * @export
 */
export type BenefitsGroupedLineItems = Array<LineItem>;
/**
 *
 * @export
 * @interface Bundle
 */
export interface Bundle {
  /**
   * Any description about the bundle
   * @type {string}
   * @memberof Bundle
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof Bundle
   */
  isRecommended: boolean;
  /**
   * LIGHT = 'Y',  SMART_PLUS = 'H',  FLEXI = 'M',  UNKNOWN = 'W',  EXTRA = 'K'
   * @type {string}
   * @memberof Bundle
   */
  fareClass: string;
  /**
   *
   * @type {BundlePrice}
   * @memberof Bundle
   */
  price: BundlePrice;
  /**
   *
   * @type {Array<BundleItem>}
   * @memberof Bundle
   */
  bundleItems: Array<BundleItem>;
  /**
   *
   * @type {string}
   * @memberof Bundle
   */
  displayName: string;
  /**
   *
   * @type {BundleData}
   * @memberof Bundle
   */
  bundleData: BundleData;
  /**
   *
   * @type {number}
   * @memberof Bundle
   */
  orderingValue: number;
  /**
   *
   * @type {Array<string>}
   * @memberof Bundle
   */
  fareUris?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof Bundle
   */
  bundleUris?: Array<string>;
  /**
   * LIGHT = 'F0D9OIQXCL', SMART = 'DB67MYPQSK', SMART_PLUS = 'H6V124RHY3', EXTRA = '6YD791G89N'
   * @type {string}
   * @memberof Bundle
   */
  bundleCode?: string;
}
/**
 *
 * @export
 * @interface BundleBenefit
 */
export interface BundleBenefit {
  /**
   *
   * @type {string}
   * @memberof BundleBenefit
   */
  code: string;
  /**
   *
   * @type {number}
   * @memberof BundleBenefit
   */
  quantity: number;
}
/**
 *
 * @export
 */
export type BundleData = Array<BundleFlight>;
/**
 *
 * @export
 * @interface BundleDetails
 */
export interface BundleDetails {
  /**
   *
   * @type {string}
   * @memberof BundleDetails
   */
  bundleDisplayName?: string;
  /**
   *
   * @type {BasketAggregateTotals}
   * @memberof BundleDetails
   */
  totals: BasketAggregateTotals;
  /**
   *
   * @type {BundleFaresLineItems}
   * @memberof BundleDetails
   */
  bundleFares?: BundleFaresLineItems;
}
/**
 *
 * @export
 */
export type BundleFaresLineItems = Array<LineItem>;
/**
 *
 * @export
 * @interface BundleFlight
 */
export interface BundleFlight {
  /**
   *
   * @type {string}
   * @memberof BundleFlight
   */
  internalId: string;
  /**
   *
   * @type {Array<BundlePassenger>}
   * @memberof BundleFlight
   */
  passengers: Array<BundlePassenger>;
  /**
   *
   * @type {UnitPrice}
   * @memberof BundleFlight
   */
  price?: UnitPrice;
}

export type UnitPrice = {
  totalPrice: number;
  adjustments?: {
    amount: number;
    code: string;
  }[];
};

/**
 *
 * @export
 * @interface BundleItem
 */
export interface BundleItem {
  /**
   *
   * @type {string}
   * @memberof BundleItem
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof BundleItem
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof BundleItem
   */
  icon: string;
  /**
   *
   * @type {number}
   * @memberof BundleItem
   */
  orderingValue: number;
  /**
   *
   * @type {number}
   * @memberof BundleItem
   */
  ancillaryCategory?: string;

  /**
   *
   * @type {string}
   * @memberof BundleItem
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof BundleItem
   */
  type?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof BundleItem
   */
  passengerIds?: Array<string>;
  /**
   *
   * @type {BundleProductPrice}
   * @memberof BundleItem
   */
  price?: BundleProductPrice;
  /**
   *
   * @type {string}
   * @memberof BundleItem
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof BundleItem
   */
  shortDescription?: string;
  /**
   *
   * @type {AncillaryProductClassification}
   * @memberof BundleItem
   */
  productClassification?: AncillaryProductClassification;
}
/**
 *
 * @export
 * @interface AncillaryProductClassification
 */
export interface AncillaryProductClassification {
  /**
   *
   * @type {string}
   * @memberof AncillaryProductClassification
   */
  typeCode?: string;
  /**
   *
   * @type {string}
   * @memberof AncillaryProductClassification
   */
  groupCode?: string;
  /**
   *
   * @type {string}
   * @memberof AncillaryProductClassification
   */
  subGroupCode?: string;
}
/**
 *
 * @export
 * @interface BundlePassenger
 */
export interface BundlePassenger {
  /**
   *
   * @type {string}
   * @memberof BundlePassenger
   */
  internalId: string;
  /**
   *
   * @type {Array<BundleBenefit>}
   * @memberof BundlePassenger
   */
  benefits: Array<BundleBenefit>;
  /**
   *
   * @type {Array<BundleProduct>}
   * @memberof BundlePassenger
   */
  products: Array<BundleProduct>;
  /**
   *
   * @type {BundlePassengerFare}
   * @memberof BundlePassenger
   */
  fare: BundlePassengerFare;
}
/**
 *
 * @export
 * @interface BundlePassengerFare
 */
export interface BundlePassengerFare {
  /**
   *
   * @type {number}
   * @memberof BundlePassengerFare
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof BundlePassengerFare
   */
  priceWithoutFlightFare: number;
}
/**
 *
 * @export
 * @interface BundleProductPrice
 */

interface BundleProductPrice {
  offerAmount: number;
  discountAmount: number;
}
/**
 *
 * @export
 * @interface BundleProduct
 */

export interface BundleProduct {
  /**
   *
   * @type {string}
   * @memberof BundleProduct
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof BundleProduct
   */
  displayName: string;
  /**
   *
   * @type {Array<BundleBenefit>}
   * @memberof BundleProduct
   */
  benefits: Array<BundleBenefit>;
  /**
   *
   * @type {BundleProductPrice}
   * @memberof BundleProduct
   */
  price?: BundleProductPrice;
}
/**
 *
 * @export
 * @interface BundlesResponse
 */
export interface BundlesResponse {
  /**
   *
   * @type {FunnelJourneyServerComponent | undefined}
   * @memberof BundlesResponse
   */
  funnelJourney: FunnelJourneyServerComponent | undefined;
  /**
   *
   * @type {Array<Bundle>}
   * @memberof BundlesResponse
   */
  bundles?: Array<Bundle>;
}
/**
 *
 * @export
 * @interface CabinBagProductLineItem
 */
export interface CabinBagProductLineItem extends ProductLineItem {}

/**
 * @export
 * @namespace CabinBagProductLineItem
 */
export namespace CabinBagProductLineItem {}
/**
 *
 * @export
 * @interface CarProductLineItem
 */
export interface CarProductLineItem extends ExternalProductLineItem {}
/**
 *
 * @export
 * @interface CarRentalGroupedLineItems
 */
export interface CarRentalGroupedLineItems extends GroupedLineItems {
  /**
   * A date-time string for car rental pickup
   * @type {string}
   * @memberof CarRentalGroupedLineItems
   */
  fromDateTime?: string;
  /**
   * A date-time string for car rental return
   * @type {string}
   * @memberof CarRentalGroupedLineItems
   */
  toDateTime?: string;
}
/**
 * Available currency
 * @export
 * @interface Currency
 */
export interface Currency {
  /**
   * Currency Code
   * @type {string}
   * @memberof Currency
   */
  currencyCode: string;
  /**
   * Name of currency
   * @type {string}
   * @memberof Currency
   */
  name: string;
}

/**
 * ISO alpha-3 code of currencies supported by easyJet (Consider getting this from a cookie rather than an argument)
 * @export
 */
export type CurrencyCodes = string;
/**
 * Standard error response
 * @export
 * @interface ErrorModel
 */
export interface ErrorModel {
  /**
   *
   * @type {Array<Error>}
   * @memberof ErrorModel
   */
  errors?: Array<Error>;
}
/**
 *
 * @export
 * @interface ExternalProductLineItem
 */
export interface ExternalProductLineItem extends ProductLineItem {}

/**
 * @export
 * @namespace ExternalProductLineItem
 */
export namespace ExternalProductLineItem {}
/**
 * Fare, could be StandardAndPromo or Flexi
 * @export
 * @interface Fare
 */
export interface Fare {
  /**
   *
   * @type {string}
   * @memberof Fare
   */
  fareType: Fare.FareTypeEnum;
  /**
   *
   * @type {PassengerType}
   * @memberof Fare
   */
  paxType: PassengerType;
  /**
   *
   * @type {FarePricing}
   * @memberof Fare
   */
  unitPrice: FarePricing;
  /**
   *
   * @type {string}
   * @memberof Fare
   */
  flightIdentification: string;
  /**
   * available fares at this price
   * @type {number}
   * @memberof Fare
   */
  unitsAvailableAtThisPrice: number;
  /**
   * total fares available on this flight
   * @type {number}
   * @memberof Fare
   */
  totalUnitsAvailable: number;
  /**
   *
   * @type {Array<FareBenefits>}
   * @memberof Fare
   */
  benefits: Array<FareBenefits>;
}

/**
 * @export
 * @namespace Fare
 */
export namespace Fare {
  /**
   * @export
   * @enum {string}
   */
  export enum FareTypeEnum {
    STANDARD = <any>'STANDARD',
    PROMOTIONAL = <any>'PROMOTIONAL'
  }
}
/**
 *
 * @export
 * @interface FareBenefits
 */
export interface FareBenefits {
  /**
   * Benefit Id
   * @type {string}
   * @memberof FareBenefits
   */
  id: string;
  /**
   * Benefit Id from legacy
   * @type {string}
   * @memberof FareBenefits
   */
  legacyId: string;
}
/**
 *
 * @export
 * @interface FarePricing
 */
export interface FarePricing {
  /**
   *
   * @type {CurrencyCodes}
   * @memberof FarePricing
   */
  currency: CurrencyCodes;
  /**
   * The net unit price excluding taxes (includes VAT)
   * @type {number}
   * @memberof FarePricing
   */
  netPrice: number;
  /**
   * The net unit price inclusive of fees excluding taxes (includes VAT)
   * @type {number}
   * @memberof FarePricing
   */
  netPriceInclusiveOfFees: number;
  /**
   *
   * @type {Array<Fee>}
   * @memberof FarePricing
   */
  fees: Array<Fee>;
  /**
   *
   * @type {Array<Tax>}
   * @memberof FarePricing
   */
  taxes: Array<Tax>;
  /**
   * Total Taxes
   * @type {number}
   * @memberof FarePricing
   */
  totalTaxes: number;
  /**
   * Total Taxes inclusive of fees
   * @type {number}
   * @memberof FarePricing
   */
  totalTaxesInclusiveOfFees: number;
  /**
   * Total Fees
   * @type {number}
   * @memberof FarePricing
   */
  totalFees: number;
  /**
   * The Gross unit price including VAT, fees, taxes
   * @type {number}
   * @memberof FarePricing
   */
  grossPrice: number;
  /**
   * The discount amount which is the difference between standard gross price and promotional gross price
   * @type {number}
   * @memberof FarePricing
   */
  discountAmount?: number;
}
/**
 *
 * @export
 * @interface Fee
 */
export interface Fee {
  /**
   * Fee Code
   * @type {string}
   * @memberof Fee
   */
  feeCode: string;
  /**
   * Fare Tax
   * @type {number}
   * @memberof Fee
   */
  feeAmount: number;
}
/**
 *
 * @export
 * @interface FlightNumber
 */
export interface FlightNumber {
  /**
   *
   * @type {string}
   * @memberof FlightNumber
   */
  carrierCode: string;
  /**
   *
   * @type {number}
   * @memberof FlightNumber
   */
  number: number;
}
/**
 *
 * @export
 * @interface FlightToAdd
 */
export interface FlightToAdd {
  /**
   * Flight number
   * @type {string}
   * @memberof FlightToAdd
   */
  flightNumber: string;
  /**
   * Carrier Code
   * @type {string}
   * @memberof FlightToAdd
   */
  carrierCode: string;
  /**
   * Departure date and time in local ISO-8601 format
   * @type {string}
   * @memberof FlightToAdd
   */
  localDepartureDateTime: string;
  /**
   * Departure date and time in local
   * @type {string}
   * @memberof FlightToAdd
   */
  localArrivalDateTime: string;
  /**
   * Origin of the flight
   * @type {string}
   * @memberof FlightToAdd
   */
  departureAirportCode: string;
  /**
   * Destination of the flight
   * @type {string}
   * @memberof FlightToAdd
   */
  arrivalAirportCode: string;
  /**
   *
   * @type {CurrencyCodes}
   * @memberof FlightToAdd
   */
  baseCurrency: CurrencyCodes;
  /**
   *
   * @type {CurrencyCodes}
   * @memberof FlightToAdd
   */
  currency: CurrencyCodes;
  /**
   *
   * @type {FlightToAddSelectedFares}
   * @memberof FlightToAdd
   */
  selectedFares: FlightToAddSelectedFares;
}
/**
 *
 * @export
 * @interface FlightToAddSelectedFares
 */
export interface FlightToAddSelectedFares {
  /**
   *
   * @type {Fare}
   * @memberof FlightToAddSelectedFares
   */
  ADT: Fare;
  /**
   *
   * @type {Fare}
   * @memberof FlightToAddSelectedFares
   */
  CHD?: Fare;
  /**
   *
   * @type {Fare}
   * @memberof FlightToAddSelectedFares
   */
  INF?: Fare;
}
/**
 *
 * @export
 * @interface FlightsAddRequest
 */
export interface FlightsAddRequest {
  /**
   *
   * @type {boolean}
   * @memberof FlightsAddRequest
   */
  isRoundTrip: boolean;
  /**
   *
   * @type {PassengerMix}
   * @memberof FlightsAddRequest
   */
  passengerMix: PassengerMix;
  /**
   *
   * @type {FlightToAdd}
   * @memberof FlightsAddRequest
   */
  outboundFlight?: FlightToAdd;
  /**
   *
   * @type {FlightToAdd}
   * @memberof FlightsAddRequest
   */
  inboundFlight?: FlightToAdd;

  passengers?: Array<PassengerDetail>;
}
/**
 *
 * @export
 * @interface FlightsDeleteQueryParams
 */
export interface FlightsDeleteQueryParams {
  /**
   *
   * @type {string}
   * @memberof FlightsDeleteQueryParams
   */
  flightToDelete: FlightsDeleteQueryParams.FlightToDeleteEnum;
}

/**
 *
 * @export
 * @interface ChangeCurrencyRequest
 */
export interface ChangeCurrencyRequest {
  /**
   *
   * @type {string}
   * @memberof ChangeCurrencyRequest
   */
  currencyCode: string;
  /**
   *
   * @type {boolean}
   * @memberof ChangeCurrencyRequest
   */
  isRoundTrip: boolean;
}

/**
 * @export
 * @namespace FlightsDeleteQueryParams
 */
export namespace FlightsDeleteQueryParams {
  /**
   * @export
   * @enum {string}
   */
  export enum FlightToDeleteEnum {
    OUTBOUND = <any>'OUTBOUND',
    INBOUND = <any>'INBOUND'
  }
}
/**
 *
 * @export
 */
export type FormattedPrice = Array<string>;
/**
 *
 * @export
 * @interface GetBundlesRequest
 */
export interface GetBundlesRequest {
  /**
   * Origin of the flight
   * @type {string}
   * @memberof GetBundlesRequest
   */
  departureAirportCode: string;
  /**
   * Origin of the flight
   * @type {string}
   * @memberof GetBundlesRequest
   */
  arrivalAirportCode: string;
  /**
   * Departure date and time in local ISO-8601 format
   * @type {string}
   * @memberof GetBundlesRequest
   */
  date: string;
  /**
   * Language code for bundles content
   * @type {string}
   * @memberof GetBundlesRequest
   */
  languageCode: string;
  /**
   * Individual class or a combination of Y, K, H, M (YMHK) (HIDE THIS IN BFF, FE shouldn't be able to update this)
   * @type {any}
   * @memberof GetBundlesRequest
   */
  fareClass: any;
  /**
   * Indicates the direction of the journey, true for outbound and false for inbound
   * @type {boolean}
   * @memberof GetBundlesRequest
   */
  isReturnFlight: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetBundlesRequest
   */
  isRoundTrip: boolean;
  /**
   * Array of passengers containing details including id, passenger type and
   * @type {Array<PassengerDetail>}
   * @memberof GetBundlesRequest
   */
  passengers: Array<PassengerDetail>;
}
/**
 *
 * @export
 * @interface GroupedLineItems
 */
export interface GroupedLineItems {
  /**
   *
   * @type {BasketAggregateTotals}
   * @memberof GroupedLineItems
   */
  totals: BasketAggregateTotals;
  /**
   * Description under each group e.g. Car Rentals
   * @type {string}
   * @memberof GroupedLineItems
   */
  descriptionText?: string;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof GroupedLineItems
   */
  lineItems: Array<LineItem>;
  /**
   *
   * @type {LineItemEditPage}
   * @memberof GroupedLineItems
   */
  editPage?: LineItemEditPage;
}
/**
 *
 * @export
 * @interface HoldLuggageProductLineItem
 */
export interface HoldLuggageProductLineItem extends ProductLineItem {}

/**
 * @export
 * @namespace HoldLuggageProductLineItem
 */
export namespace HoldLuggageProductLineItem {}
/**
 *
 * @export
 * @interface InsuranceGroupedLineItems
 */
export interface InsuranceGroupedLineItems extends GroupedLineItems {}
/**
 *
 * @export
 * @interface Journey
 */
export interface Journey {
  /**
   *
   * @type {FlightNumber}
   * @memberof Journey
   */
  flightNumber: FlightNumber;
  /**
   *
   * @type {string}
   * @memberof Journey
   */
  flightSegmentId: string;
  /**
   * Origin of the flight
   * @type {string}
   * @memberof Journey
   */
  departureAirportCode: string;
  /**
   * Origin of the flight airport name
   * @type {string}
   * @memberof Journey
   */
  departureAirportName: string;
  /**
   * Destination of the flight
   * @type {string}
   * @memberof Journey
   */
  arrivalAirportCode: string;
  /**
   * Origin of the flight airport name
   * @type {string}
   * @memberof Journey
   */
  arrivalAirportName: string;
  /**
   * airtport time and date
   * @type {string}
   * @memberof Journey
   */
  localDepartureDateTime: string;
  /**
   * aitport time and date
   * @type {string}
   * @memberof Journey
   */
  localArrivalDateTime: string;
  /**
   * The offer key that would hold the bundle information for this joruney
   * @type {string}
   * @memberof Journey
   */
  journeyOfferKey: string;
  /**
   *
   * @type {AirfareDetails}
   * @memberof Journey
   */
  airfare: AirfareDetails;
  /**
   *
   * @type {BundleDetails}
   * @memberof Journey
   */
  bundle?: BundleDetails;
  /**
   *
   * @type {BenefitsGroupedLineItems}
   * @memberof Journey
   */
  benefits: BenefitsGroupedLineItems;
  /**
   *
   * @type {AddonsGroupedLineItems}
   * @memberof Journey
   */
  addons?: AddonsGroupedLineItems;
  /**
   *
   * @type {FlexPassGroupedLineItems}
   * @memberof Journey
   */
  flexPass?: FlexPassGroupedLineItems;
  /**
   *
   * @type {BasketAggregateTotals}
   * @memberof Journey
   */
  totals: BasketAggregateTotals;
  /**
   *
   * @type {BasketPrice}
   * @memberof Journey
   */
  totalDiscount?: BasketPrice;
}
/**
 * Forms a horizontal slice or an airport to aiport outbound and inbound slice of two grids layout horizontally
 * @export
 * @interface JourneyPairs
 */
export interface JourneyPairs {
  /**
   *
   * @type {BasketAggregateTotals}
   * @memberof JourneyPairs
   */
  totals: BasketAggregateTotals;
  /**
   *
   * @type {boolean}
   * @memberof JourneyPairs
   */
  isRoundtrip: boolean;
  /**
   *
   * @type {Journey}
   * @memberof JourneyPairs
   */
  outboundJourney?: Journey;
  /**
   *
   * @type {Journey}
   * @memberof JourneyPairs
   */
  inboundJourney?: Journey;
  /**
   *
   * @type {BasketPrice}
   * @memberof JourneyPairs
   */
  totalDiscount?: BasketPrice;
}
/**
 *
 * @export
 * @interface LineItem
 */
export interface LineItem extends BaseLineItem {
  /**
   * Quantity for this line item
   * @type {number}
   * @memberof LineItem
   */
  quantity: number;
  /**
   *
   * @type {BasketPrice}
   * @memberof LineItem
   */
  unitPrice: BasketPrice;
  /**
   * Controls the visibilty of this line item's quantity
   * @type {boolean}
   * @memberof LineItem
   */
  hideQuantity?: boolean;
  /**
   * Defines whether this LineItem can be removed individually from the basket
   * @type {boolean}
   * @memberof LineItem
   */
  isRemovable?: boolean;
  /**
   *
   * @type {LineItemEditPage}
   * @memberof LineItem
   */
  editPage?: LineItemEditPage;
  /**
   *
   * @type {string}
   * @memberof LineItem
   */
  pricing: LineItem.PricingEnum;
  /**
   *
   * @type {string}
   * @memberof LineItem
   */
  paymentCollector: LineItem.PaymentCollectorEnum;
  /**
   *
   * @type {LineItemCategory}
   * @memberof LineItem
   */
  category: LineItemCategory;
}

/**
 * @export
 * @namespace LineItem
 */
export namespace LineItem {
  /**
   * @export
   * @enum {string}
   */
  export enum PricingEnum {
    AIRFARE = <any>'AIRFARE',
    ADDON = <any>'ADDON',
    BUNDLE = <any>'BUNDLE',
    INCLUDEDINAIRFARE = <any>'INCLUDED_IN_AIRFARE',
    INCLUDEDINBUNDLE = <any>'INCLUDED_IN_BUNDLE',
    INCLUDEDINPRODUCT = <any>'INCLUDED_IN_PRODUCT',
    PAYLATER = <any>'PAY_LATER'
  }
  /**
   * @export
   * @enum {string}
   */
  export enum PaymentCollectorEnum {
    EASYJET = <any>'EASYJET',
    CARLEASER = <any>'CAR_LEASER',
    INSURER = <any>'INSURER'
  }
}
/**
 *
 * @export
 * @interface LineItemCategory
 */
export interface LineItemCategory {
  /**
   *
   * @type {string}
   * @memberof LineItemCategory
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof LineItemCategory
   */
  displayName: string;
  /**
   *
   * @type {number}
   * @memberof LineItemCategory
   */
  orderingValue: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemCategory
   */
  hideInBreakdown?: boolean;
}
/**
 *
 * @export
 * @interface LineItemEditPage
 */
export interface LineItemEditPage {
  /**
   *
   * @type {string}
   * @memberof LineItemEditPage
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof LineItemEditPage
   */
  url: string;
}
/**
 *
 * @export
 * @interface ModelError
 */
export interface ModelError {
  /**
   *
   * @type {number}
   * @memberof ModelError
   */
  code: number;
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  message: string;
}
/**
 *
 * @export
 * @interface PassengerDetail
 */

export interface PassengerDetail {
  /**
   * Internal Id for the passenger (DISCUSS)
   * @type {string}
   * @memberof PassengerDetail
   */
  id: string;
  /**
   * Whether this passenger is an eJ plus
   * @type {boolean}
   * @memberof PassengerDetail
   */
  isEjPlus: boolean;
  /**
   * Title of the passenger
   * @type {PassengerTitle}
   * @memberof PassengerDetail
   */
  title?: PassengerTitle;
  /**
   * firstname of the passenger
   * @type {string}
   * @memberof PassengerDetail
   */
  firstName?: string;
  /**
   * lastname of the passenger
   * @type {string}
   * @memberof PassengerDetail
   */
  lastName?: string;
  /**
   * type of the passenger - Adult, Child, Infant
   * @type {PassengerType}
   * @memberof PassengerDetail
   */
  type: PassengerType;
  /**
   * age of the passenger
   * @type {number}
   * @memberof PassengerDetail
   */
  age?: number;
  /**
   * ejPlus number of the passenger
   * @type {string}
   * @memberof PassengerDetail
   */
  ejPlusNumber?: string;
  /**
   * nifNumber of the passenger
   * @type {string}
   * @memberof PassengerDetail
   */
  nifNumber?: string;
  /**
   * specialServiceRequestCodes of the passenger
   * @type {string[]}
   * @memberof PassengerDetail
   */
  specialServiceRequestCodes?: string[];
}

export enum PassengerTitle {
  Mr = 0,
  Mrs = 1,
  Ms = 2,
  Miss = 3,
  Infant = 4,
  Object = 5
}
/**
 *
 * @export
 * @interface PassengerMix
 */
export interface PassengerMix {
  /**
   * Number of Adults
   * @type {number}
   * @memberof PassengerMix
   */
  ADT: number;
  /**
   * Number of Children
   * @type {number}
   * @memberof PassengerMix
   */
  CHD: number;
  /**
   * Number of Infants
   * @type {number}
   * @memberof PassengerMix
   */
  INF: number;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum PassengerType {
  ADT = 'ADT',
  CHD = 'CHD',
  INF = 'INF',
  UNKNOWN = 'UNKNOWN'
}
/**
 *
 * @export
 * @interface ProductLineItem
 */
export interface ProductLineItem extends LineItem {
  /**
   * The type of product in the additional product line items
   * @type {string}
   * @memberof ProductLineItem
   */
  productType: ProductLineItem.ProductTypeEnum;
}

/**
 * @export
 * @namespace ProductLineItem
 */
export namespace ProductLineItem {
  /**
   * @export
   * @enum {string}
   */
  export enum ProductTypeEnum {
    SEATS = <any>'SEATS',
    CABINBAGS = <any>'CABIN_BAGS',
    LUGGAGE = <any>'LUGGAGE',
    VOUCHER = <any>'VOUCHER',
    UNKNOWN = <any>'UNKNOWN'
  }
}
/**
 *
 * @export
 * @interface SeatProductLineItem
 */
export interface SeatProductLineItem extends ProductLineItem {}

/**
 * @export
 * @namespace SeatProductLineItem
 */
export namespace SeatProductLineItem {}
/**
 *
 * @export
 * @interface SetBundleRequest
 */
export interface SetBundleRequest {
  /**
   *
   * @type {string}
   * @memberof SetBundleRequest
   */
  fareClass: string;
  /**
   *
   * @type {BundleData}
   * @memberof SetBundleRequest
   */
  bundleData: BundleData;
  /**
   *
   * @type {Array<string>}
   * @memberof SetBundleRequest
   */
  fareUris?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SetBundleRequest
   */
  bundleUris?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SetBundleRequest
   */
  sessionId?: string;
  /**
   *
   * @type {string}
   * @memberof SetBundleRequest
   */
  bundleCode?: string;
  /**
   *
   * @type {string}
   * @memberof SetBundleRequest
   */
  bundleName?: string;
  /**
   *
   * @type {boolean}
   * @memberof SetBundleRequest
   */
  passengerIdsPairings?: PassengerIdsPairing[];
}
/**
 *
 * @export
 * @interface Tax
 */
export interface Tax {
  /**
   * Fare Tax Code
   * @type {string}
   * @memberof Tax
   */
  taxCode: string;
  /**
   * Fare Tax
   * @type {number}
   * @memberof Tax
   */
  taxAmount: number;
}
/**
 *
 * @export
 * @interface TravelInsuranceProductLineItem
 */
export interface TravelInsuranceProductLineItem extends ExternalProductLineItem {}
/**
 * Unlocalised fare name from Stimson Enum
 * @export
 * @enum {string}
 */
export enum UnlocalisedStimsonFareType {
  STANDARD = <any>'STANDARD'
}
/**
 *
 * @export
 * @interface VoucherProductLineItem
 */
export interface VoucherProductLineItem extends ProductLineItem {}

/**
 * @export
 * @namespace VoucherProductLineItem
 */
export namespace VoucherProductLineItem {}

export type BundleError = {
  type: string;
};

export * from './funnelJourney';
